import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "as-time"
}
const _hoisted_2 = {
  key: 2,
  class: "as-count"
}

import { ref, computed } from "vue";
import MatchEnum from "~src/enums/MatchEnum";
import type { IIncident, IPlayer, IIncidentStatistic } from "~src/interfaces";


const __default__ = {};

interface IProps {
  player: IPlayer;
  types: number[];
  classname: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SquadIncident',
  props: {
    player: {},
    types: { default: [1, 3, 4, 8, 9, 15, 17] },
    classname: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;

const incidentData = computed(() => {
  const incidents: IIncident[] = [];
  for(const incident of props.player.incidents) {
    if(!props.types.includes(incident.type)) continue;

    if(incident.type === 1) {
      // Bàn thắng
      if (incident?.player?.id === props.player.id) {
        const index = incidents.findIndex((item: IIncident) => item.type === 1 && item?.player?.id === props.player.id);
        if(index === -1) {
          incidents.push({
            ...incident,
            count: 1
          });
        } else {
          incidents[index].count = incidents[index].count + 1;
        }
      }

      // Kiến tạo
      if (incident?.assist1?.id === props.player.id) {
        const index = incidents.findIndex((item: IIncident) => item.type === 1 && item?.assist1?.id === props.player.id);
        if(index === -1) {
          incidents.push({
            ...incident,
            count: 1
          });
        } else {
          incidents[index].count = incidents[index].count + 1;
        }
      }
    } else {
      incidents.push(incident);
    }
  }

  return incidents;
})

const getIncidentIcon = (incident: IIncidentStatistic | IIncident) => {
  const inci: IIncidentStatistic | undefined = listIncidents.find(
    (item: IIncidentStatistic) => item.type === incident.type
  );

  if (inci && props.types.includes(inci.type)) {
    // Kiến tạo
    if (inci.type === 1 && incident?.player?.id !== props.player.id) {
      const inci1: IIncidentStatistic | undefined = listIncidents.find(
        (item: IIncidentStatistic) => item.type === 1111
      );

      return inci1?.icon;
    }
    // else if (inci.type === 9 && incident?.out_player?.id === props.player.id) {
    //   const inci1: IIncidentStatistic | undefined = listIncidents.find(
    //     (item: IIncidentStatistic) => item.type === 10
    //   );

    //   return inci1?.icon;
    // }

    return inci.icon;
  }

  return null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-incident ${_ctx.classname}`)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incidentData.value, (incident, incidentKey) => {
      return (_openBlock(), _createElementBlock("div", {
        key: incidentKey,
        class: _normalizeClass(`as-incident-item as-incident-item-${incident.type}`)
      }, [
        (getIncidentIcon(incident))
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(getIncidentIcon(incident)), { key: 0 }))
          : _createCommentVNode("", true),
        ([9].includes(incident.type))
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(incident.time) + "'", 1))
          : ([1].includes(incident.type) && incident.count > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(incident.count), 1))
            : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ], 2))
}
}

})